import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import Icon from '../../../../icons/Icon';
import { WatchlistDateModel, WatchlistEducationModel } from '../../../../domain/watchlist/WatchlistDomains';
import WatchlistUtil from '../../../../util/WatchlistUtil';
import LanguageUtil from '../../../../util/LanguageUtil';

class WatchlistEducationsModalComponent extends Component<Props> {
  render() {
    const { visible, onClose } = this.props;
    return (
      <Dialog
        header={this.getHeader}
        className={'custom-dialog w-2/5 h-auto'}
        visible={visible}
        onHide={onClose}
        closable={false}
        closeOnEscape={true}
        dismissableMask={true}
      >
        {this.getContent()}
      </Dialog>
    );
  }

  private getHeader = () => {
    return (
      <div className={'bg-[#F9FAFB] h-[54px] rounded-t-[6px] flex items-center justify-between align-center pl-4'}>
        <div className={'flex items-center justify-start align-center w-full lg:w-auto gap-x-2'}>
          <Icon icon={'kyc_educationicon'} size={18} />
          <div className={'text-f-black-2 font-normal text-md'}>{LanguageUtil.get({ id: 'common.label.education', defaultMessage: 'Education' })}</div>
        </div>
      </div>
    );
  };

  private getContent = () => {
    const { selectedData } = this.props;
    return (
      <div className={'h-full w-full p-0 m-0'}>
        <div className={'flex justify-between border-b p-3 text-f-black-2 text-sm'}>
          <div className={'flex gap-x-3 items-center w-1/3'}>
            <Icon icon={'kyc_educationicon'} size={18} />
            <span>{LanguageUtil.get({ id: 'common.label.name', defaultMessage: 'name' })}</span>
          </div>
          <span className={'w-2/3 text-justify text-f-black-3'}>
            {selectedData?.name || LanguageUtil.get({ id: 'common.label.notAvailable', defaultMessage: 'Not Available' })}
          </span>
        </div>
        <div className={'flex justify-between border-b p-3 text-f-black-2 text-sm'}>
          <div className={'flex gap-x-3 items-center w-1/3'}>
            <Icon icon={'kyc_dateofissueicon'} size={18} />
            <span>{LanguageUtil.get({ id: 'common.label.startDate', defaultMessage: 'Start Date' })}</span>
          </div>
          <span className={'w-2/3 text-justify text-f-black-3'}>{this.getDate(selectedData?.startDate)}</span>
        </div>
        <div className={'flex justify-between border-b p-3 text-f-black-2 text-sm'}>
          <div className={'flex gap-x-3 items-center w-1/3'}>
            <Icon icon={'kyc_dateofissueicon'} size={18} />
            <span>{LanguageUtil.get({ id: 'common.label.endDate', defaultMessage: 'End Date' })}</span>
          </div>
          <span className={'w-2/3 text-justify text-f-black-3'}>{this.getDate(selectedData?.endDate)}</span>
        </div>
        <div className={'flex justify-between border-b p-3 text-f-black-2 text-sm'}>
          <div className={'flex gap-x-3 items-center w-1/3'}>
            <Icon icon={'link'} size={18} />
            <span>{LanguageUtil.get({ id: 'common.label.source', defaultMessage: 'Source' })}</span>
          </div>
          <span
            className={'flex items-center text-[12px] underline text-normal text-[#458EF7] cursor-pointer w-2/3 text-justify'}
            onClick={() => window.open(selectedData?.source, '_blank')}
          >
            {LanguageUtil.get({ id: 'common.label.website', defaultMessage: 'Website' })}
          </span>
        </div>
      </div>
    );
  };

  private getDate = (data: WatchlistDateModel | undefined) => {
    if (data == undefined) return LanguageUtil.get({ id: 'common.label.notAvailable', defaultMessage: 'Not Available' });
    return `${data.day || ''} ${WatchlistUtil.getMonth(data.month)} ${data.year || ''}`;
  };
}

interface Props {
  visible: boolean;
  selectedData: WatchlistEducationModel | undefined;
  onClose: () => void;
}

export default WatchlistEducationsModalComponent;
